import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setLanguage } from '@/shared/actions';
import { getLanguage } from '@/services/GRNLwithoutDep';
import { translate } from '@/services/TranslationService';
import {
  NovovilleButton,
  NovovilleInput,
  Typography,
} from '@/components/novoville';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { toast } from '@/components/ui/use-toast';
import AuthPageContainer from './AuthPageContainter';
import { register } from './actions';
import ReCAPTCHAInput from './components/ReCAPTCHAInput';

const RegistrationPage = ({ history }) => {
  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    email_subscription: true,
    recaptchaToken: null,
  });

  const dispatch = useDispatch();

  const initialLanguage = getLanguage();

  const [selectedLanguage, setSelectedLanguage] = useState(
    initialLanguage || ''
  );

  const handleLanguageChange = async (newLanguage) => {
    setSelectedLanguage(newLanguage);
    await dispatch(setLanguage(newLanguage));
  };

  const navigate = useCallback(
    (path) => {
      history.push(path, {
        from: '/registration-page',
      });
    },
    [history]
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle form submission logic here, if needed

    const { name, surname, email_subscription, recaptchaToken } = formData;

    try {
      const response = await dispatch(
        register(name, surname, email_subscription, recaptchaToken)
      );

      if (response) navigate(`/login-confirmation`);
    } catch (error) {
      toast({
        title: translate('Error'),
        description: translate(error),
        variant: 'destructive',
      });
      return;
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleRecaptchaVerify = (token) => {
    setFormData((prevData) => ({
      ...prevData,
      recaptchaToken: token,
    }));
  };

  const { name, surname, email_subscription } = formData;

  return (
    <AuthPageContainer
      language={selectedLanguage}
      handleLanguageChange={handleLanguageChange}
    >
      <Card className="w-full h-full sm:p-[40px] sm:drop-shadow-md drop-shadow-none shadow-none text-gray-800 px-[24px] border-none">
        <form className="h-full flex flex-col" onSubmit={handleSubmit}>
          <CardHeader className="text-center p-0 max-w-60 mx-auto mb-6">
            <CardTitle className="mb-3">
              <Typography variant="semibold_24">
                {translate("You're almost there!")}
              </Typography>
            </CardTitle>
            <CardDescription className="mt-0">
              <Typography variant="regular_16">
                {translate(
                  `Please enter your name & surname to continue. Make sure it's correct so your council can contact you effectively.`
                )}
              </Typography>
            </CardDescription>
          </CardHeader>
          <CardContent className="mb-8 p-0 flex flex-col space-y-3">
            <div className="flex flex-col space-y-2">
              <label htmlFor="name" className="text-sm font-medium">
                {translate('Name')}
              </label>
              <NovovilleInput
                type="text"
                id="name"
                name="name"
                value={name}
                onChange={handleInputChange}
                className="p-2 border rounded"
                required
              />
            </div>
            <div className="flex flex-col space-y-2">
              <label htmlFor="surname" className="text-sm font-medium">
                {translate('surname')}
              </label>
              <NovovilleInput
                type="text"
                id="surname"
                name="surname"
                value={surname}
                onChange={handleInputChange}
                className="p-2 border rounded"
                required
              />
            </div>
            <div className="flex items-center space-x-2 mt-4">
              <input
                type="checkbox"
                id="email_subscription"
                name="email_subscription"
                className="accent-strongCyan"
                checked={email_subscription}
                onChange={(e) =>
                  setFormData((prevData) => ({
                    ...prevData,
                    email_subscription: e.target.checked,
                  }))
                }
              />
              <label htmlFor="email_subscription" className="text-sm">
                {translate('Receive city announcements')}
              </label>
            </div>

            <ReCAPTCHAInput
              onVerify={handleRecaptchaVerify}
              className="ml-auto"
            />

            <Typography variant="regular_14" className="text-gray-500">
              {translate('agreeWith')}
            </Typography>
          </CardContent>
          <CardFooter className="p-0 flex flex-col justify-center items-center mt-auto">
            <NovovilleButton
              type="submit"
              variant="primary"
              className="w-full mb-4"
            >
              {translate('Continue')}
            </NovovilleButton>
          </CardFooter>
        </form>
      </Card>
    </AuthPageContainer>
  );
};

export default withRouter(RegistrationPage);
